import {useCallback, useEffect, useMemo} from "react";
import {css} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {SelectAsyncFieldControlled, useFormContextRHF} from "@pg-design/rhf-components-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";
import {mapSuggestedRegionsToSelectOptions, SUGGESTED_REGIONS_POLAND} from "@pg-rp/common-constants";
import {Country} from "@pg-rp/common-types";

import {useLocationAutocomplete} from "@/features/regions/hooks/use_location_autocomplete";

import {HomeMatchPreferencesLocationSearchMethod} from "../../constants/preferences/home_match_preferences_values";
import {HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT} from "../../constants/preferences/home_match_user_preferences_location_content";
import {getHomeMatchUserPreferencesLocationSelectComponents} from "../../utils/get_home_match_user_preferences_location_select_components";
import {getHomeMatchUserPreferencesLocationSelectStyles} from "../../utils/get_home_match_user_preferences_location_select_styles";

interface IProps {
    hideIcons?: boolean;
    name: string;
    nextPlaceholder?: string;
    onBlur?: () => void;
    onFocus?: () => void;
    placeholder?: string;
    regions?: IOption<number>[];
}

const {LOADING_MESSAGE, MIN_INPUT_LENGTH_MESSAGE, NO_RESULTS_MESSAGE, PLACEHOLDER} = HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT;
const DESKTOP_VISIBLE_LOCATION_CHIPS = 3;
const MOBILE_VISIBLE_LOCATION_CHIPS = 2;
const LOCATION_QUERY_MIN_LENGTH = 2;

const getNoOptionsMessage = (inputValue: string) => {
    if (inputValue.length < 2) return MIN_INPUT_LENGTH_MESSAGE;

    return NO_RESULTS_MESSAGE;
};

export const HomeMatchUserPreferencesLocation = (props: IProps) => {
    const {hideIcons = false, name, nextPlaceholder, onBlur, onFocus, placeholder = PLACEHOLDER, regions} = props;
    const {isMobile} = useUserDevice();
    const visibleLocationChips = isMobile ? MOBILE_VISIBLE_LOCATION_CHIPS : DESKTOP_VISIBLE_LOCATION_CHIPS;

    const {loadOptions} = useLocationAutocomplete({country: Country.POLAND});
    const {setValue} = useFormContextRHF();
    const rememberLocationSearchMethod = useCallback(
        (inputValue: string) => {
            const {MANUAL_INPUT, POPULAR_SEARCH_CLICK} = HomeMatchPreferencesLocationSearchMethod;

            setValue("locationSearchMethod", inputValue.trim().length >= LOCATION_QUERY_MIN_LENGTH ? MANUAL_INPUT : POPULAR_SEARCH_CLICK, {shouldDirty: false});
        },
        [setValue]
    );
    const suggestedRegionOptions = useMemo(() => mapSuggestedRegionsToSelectOptions(SUGGESTED_REGIONS_POLAND), []);
    const selectComponents = useMemo(
        () =>
            getHomeMatchUserPreferencesLocationSelectComponents({
                hideIcons,
                isMobile,
                nextPlaceholder,
                onLocationInputSelect: rememberLocationSearchMethod,
                visibleLocationChips
            }),
        [hideIcons, isMobile, nextPlaceholder, rememberLocationSearchMethod, visibleLocationChips]
    );
    const selectStyles = getHomeMatchUserPreferencesLocationSelectStyles({hideIcons, isMobile});

    useEffect(() => {
        if (!regions) return;

        setValue(name, regions);
    }, [name, regions, setValue]);

    return (
        <div className={locationInputWrapperStyle}>
            {!hideIcons && (
                <div className={locationIconStyle}>
                    <MapMarkerOutlineIcon size="2" />
                </div>
            )}

            <SelectAsyncFieldControlled<IOption<number>, true>
                components={selectComponents}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.REGION_INPUT}
                defaultOptions={suggestedRegionOptions}
                isClearable={false}
                isMulti
                loadOptions={loadOptions}
                loadingMessage={() => LOADING_MESSAGE}
                name={name}
                noOptionsMessage={({inputValue}) => <Text variant="body_copy_2">{getNoOptionsMessage(inputValue)}</Text>}
                onBlur={onBlur}
                onFocus={onFocus}
                placeholder={placeholder}
                required
                styles={selectStyles}
                wrapperClassName={selectWrapperStyle}
            />
        </div>
    );
};

const locationInputWrapperStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center"
});

const locationIconStyle = css({
    position: "absolute",
    top: 2.5,
    bottom: 0,
    left: 1.5,
    zIndex: "var(--zIndex-base)",
    width: "calc(var(--globals-baseUnit) * 3)",
    height: "auto",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    pointerEvents: "none",
    userSelect: "none"
});

const selectWrapperStyle = css({
    width: "100%",
    backgroundColor: "var(--colors-white)",
    "&[data-state='error']": {
        borderColor: "var(--colors-danger)"
    }
});
import {useCallback, useEffect, useMemo} from "react";
import {css} from "@panda/css";

import {MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {SelectAsyncFieldControlled, useFormContextRHF} from "@pg-design/rhf-components-module";
import {IOption} from "@pg-design/select-module";
import {Text} from "@pg-design/text-module";
import {KM_PREFERENCES_FORM_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";
import {mapSuggestedRegionsToSelectOptions, SUGGESTED_REGIONS_POLAND} from "@pg-rp/common-constants";
import {Country} from "@pg-rp/common-types";

import {useLocationAutocomplete} from "@/features/regions/hooks/use_location_autocomplete";

import {HomeMatchPreferencesLocationSearchMethod} from "../../constants/preferences/home_match_preferences_values";
import {HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT} from "../../constants/preferences/home_match_user_preferences_location_content";
import {getHomeMatchUserPreferencesLocationSelectComponents} from "../../utils/get_home_match_user_preferences_location_select_components";
import {getHomeMatchUserPreferencesLocationSelectStyles} from "../../utils/get_home_match_user_preferences_location_select_styles";

interface IProps {
    hideIcons?: boolean;
    name: string;
    nextPlaceholder?: string;
    onBlur?: () => void;
    onFocus?: () => void;
    placeholder?: string;
    regions?: IOption<number>[];
}

const {LOADING_MESSAGE, MIN_INPUT_LENGTH_MESSAGE, NO_RESULTS_MESSAGE, PLACEHOLDER} = HOME_MATCH_USER_PREFERENCES_LOCATION_CONTENT;
const DESKTOP_VISIBLE_LOCATION_CHIPS = 3;
const MOBILE_VISIBLE_LOCATION_CHIPS = 2;
const LOCATION_QUERY_MIN_LENGTH = 2;

const getNoOptionsMessage = (inputValue: string) => {
    if (inputValue.length < 2) return MIN_INPUT_LENGTH_MESSAGE;

    return NO_RESULTS_MESSAGE;
};

export const HomeMatchUserPreferencesLocation = (props: IProps) => {
    const {hideIcons = false, name, nextPlaceholder, onBlur, onFocus, placeholder = PLACEHOLDER, regions} = props;
    const {isMobile} = useUserDevice();
    const visibleLocationChips = isMobile ? MOBILE_VISIBLE_LOCATION_CHIPS : DESKTOP_VISIBLE_LOCATION_CHIPS;

    const {loadOptions} = useLocationAutocomplete({country: Country.POLAND});
    const {setValue} = useFormContextRHF();
    const rememberLocationSearchMethod = useCallback(
        (inputValue: string) => {
            const {MANUAL_INPUT, POPULAR_SEARCH_CLICK} = HomeMatchPreferencesLocationSearchMethod;

            setValue("locationSearchMethod", inputValue.trim().length >= LOCATION_QUERY_MIN_LENGTH ? MANUAL_INPUT : POPULAR_SEARCH_CLICK, {shouldDirty: false});
        },
        [setValue]
    );
    const suggestedRegionOptions = useMemo(() => mapSuggestedRegionsToSelectOptions(SUGGESTED_REGIONS_POLAND), []);
    const selectComponents = useMemo(
        () =>
            getHomeMatchUserPreferencesLocationSelectComponents({
                hideIcons,
                isMobile,
                nextPlaceholder,
                onLocationInputSelect: rememberLocationSearchMethod,
                visibleLocationChips
            }),
        [hideIcons, isMobile, nextPlaceholder, rememberLocationSearchMethod, visibleLocationChips]
    );
    const selectStyles = getHomeMatchUserPreferencesLocationSelectStyles({hideIcons, isMobile});

    useEffect(() => {
        if (!regions) return;

        setValue(name, regions);
    }, [name, regions, setValue]);

    return (
        <div className={locationInputWrapperStyle}>
            {!hideIcons && (
                <div className={locationIconStyle}>
                    <MapMarkerOutlineIcon size="2" />
                </div>
            )}

            <SelectAsyncFieldControlled<IOption<number>, true>
                components={selectComponents}
                dataTestId={KM_PREFERENCES_FORM_TEST_IDS.REGION_INPUT}
                defaultOptions={suggestedRegionOptions}
                isClearable={false}
                isMulti
                loadOptions={loadOptions}
                loadingMessage={() => LOADING_MESSAGE}
                name={name}
                noOptionsMessage={({inputValue}) => <Text variant="body_copy_2">{getNoOptionsMessage(inputValue)}</Text>}
                onBlur={onBlur}
                onFocus={onFocus}
                placeholder={placeholder}
                required
                styles={selectStyles}
                wrapperClassName={selectWrapperStyle}
            />
        </div>
    );
};

const locationInputWrapperStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center"
});

const locationIconStyle = css({
    position: "absolute",
    top: 2.5,
    bottom: 0,
    left: 1.5,
    zIndex: "var(--zIndex-base)",
    width: "calc(var(--globals-baseUnit) * 3)",
    height: "auto",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    pointerEvents: "none",
    userSelect: "none"
});

const selectWrapperStyle = css({
    width: "100%",
    backgroundColor: "var(--colors-white)",
    "&[data-state='error']": {
        borderColor: "var(--colors-danger)"
    }
});
